import React, { useState } from 'react';
import type { AccountProps } from '../../types';
import { Icons } from '../../Components';
import { WalletApi } from '../api';
import { Button, Text, View } from '../../Components/Themed';
import { useColors } from '../../constants/useColors';

type UnlinkAccountCardProps = {
    account:AccountProps,
    onCancel: () => void,
    onRemove: (acct:AccountProps) => void
}

const RemoveAccountCard = ({ account, onCancel, onRemove }:UnlinkAccountCardProps) => {
    const Colors = useColors();
    const [ loading, setLoading ] = useState(false);
    const [ disclaimer, setDisclaimer ] = useState(false);

    //Player accounts
    //Filter to ensure only this player and not inactive accounts

    const handleRemove = async() => {
        if(!account){ return }
        if(loading){ return }
        if(!disclaimer){ return }
        setLoading(true);
        const resp = await WalletApi.removeAccount(account.account_id)
        onRemove(resp.account)
        setLoading(false);
    }

    return (
        <View style={{ flex:1 }}>
            <View nativeID='snooze_disclaimer' style={{ flex:1, margin:10, justifyContent:'flex-end' }}>
                <Button style={{ flexDirection:'row', padding:5 }} onPress={() => setDisclaimer(!disclaimer)}>
                    <View style={{ justifyContent:'center', marginRight:10, alignItems:'center', height:25, width:25, borderRadius:4, backgroundColor: disclaimer ? Colors.text.h1 : 'transparent', borderWidth:1, borderColor:Colors.text.h1 }}>
                        {disclaimer ?
                        <Icons.CheckIcon size={14} color={Colors.text.h1} />
                        :<></>}
                    </View>
                    <Text style={{flex:1}} size={14} theme='description'>I confirm my request to remove my account.  I understand that this will take up to 24 hours to come into effect. I understand that I will no longer be able to use this account to transact.</Text>
                </Button>
            </View>
            <View nativeID='action_row' style={{ flexDirection:'row', padding:20 }}>
                <Button
                    style={{ flex:1, marginRight:5, opacity: 1 }}
                    title={'CANCEL'}
                    type='close'
                    onPress={() => onCancel()}
                />
                <Button
                    style={{ flex:3, opacity: !disclaimer||loading?0.5:1 }}
                    disabled={!disclaimer}
                    loading={loading}
                    title={'REMOVE ACCOUNT'}
                    type='error'
                    onPress={() => handleRemove()}
                />
            </View>
        </View>
    )
}

export default RemoveAccountCard